module.exports = __webpack_public_path__ + "static/img/titleShare.5b5a508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobel/titleShare.png
// module id = +lRw
// module chunks = 1